import { Form } from "antd";
import { OnlyPrimary } from "./filter-form-only-primary";
import { OnlyOther } from "./filter-form-only-other";
import { AllFilters } from "./filter-form-all-filters";
import { useFilterForm } from "../model/use-filter-form";

export type FilterControlsProps = {
  view?: "onlyPrimary" | "onlyOther" | "all";
};

export function FilterForm({ view = "all" }: FilterControlsProps) {
  const formProps = useFilterForm();

  return (
    <Form layout="vertical" {...formProps}>
      {view === "onlyPrimary" && <OnlyPrimary />}
      {view === "onlyOther" && <OnlyOther />}
      {view === "all" && <AllFilters />}
    </Form>
  );
}
